import { render, staticRenderFns } from "./HeadmenuView.vue?vue&type=template&id=f1a3c5aa&scoped=true&"
import script from "./HeadmenuView.vue?vue&type=script&lang=js&"
export * from "./HeadmenuView.vue?vue&type=script&lang=js&"
import style0 from "./HeadmenuView.vue?vue&type=style&index=0&id=f1a3c5aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a3c5aa",
  null
  
)

export default component.exports